import { FC } from 'react';
import { EventProps } from 'react-big-calendar';

import { CalendarEvent } from 'types/interviewSlots';

import styles from './MonthEvent.module.scss';

const MonthEvent: FC<EventProps<CalendarEvent>> = () => (
  <div className={styles.monthEvent}>
    <span className={styles.dot} aria-hidden />
  </div>
);

export default MonthEvent;
